/* eslint-disable arrow-body-style */
import { TaskEither, tryCatch } from 'fp-ts/lib/TaskEither';
import { toError } from 'fp-ts/lib/Either';

const createRequest = (method: string) => (url: string) => new Request(url, { method });

export const createGetRequest = createRequest('get');
export const createHeadRequest = createRequest('head');
export const createPutRequest = createRequest('put');
export const createPostRequest = createRequest('post');
export const createDeleteRequest = createRequest('delete');

export const fetchRequest = (request: Request): TaskEither<Error, Response> => tryCatch(
  () => fetch(request),
  toError,
);
